import React, { Component } from "react";
import { bindActionCreators } from "redux";
import {
	exportSales,
	exportToDownloadSales,
	getAllSales,
	handleChangeFilterStatements,
	handleErrors,
	handleResetFilterAndExport,
	openOrCloseExportModal,
	openOrCloseFilterModal
} from "../../../actions/sales";
import { getAllFidelityPlans, getFidelityPlansFromUserSales } from "../../../actions/util";
import connect from "react-redux/es/connect/connect";
import Form from "../../../../shared/Form/Form";
import Select from "../../../../shared/Select/Select";
import DatePeriodFilter from "./filter/DatePeriodFilter";
import Input from "../../../../shared/Input/Input";
import FidelityPlansCheckboxSelector from "./filter/FidelityPlansCheckboxSelector";
import StatusCheckboxSelector from "./filter/StatusCheckboxSelector";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";
import ModalTooLongContentTitle from "../../../../shared/ModalTooLongContent/ModalTooLongContentTitle";
import ModalTooLongContent from "../../../../shared/ModalTooLongContent/ModalTooLongContent";
import StatusRadioSelector from "./filter/StatusRadioSelector";
import PeriodTypeRadioSelector from "./filter/PeriodTypeRadioSelector";
import { decDaysToDate, formatDateToComputerDate } from "../../../shared/utils";
import Radio from "../../../../shared/Radio/Radio";
import { isMobile } from "./../../../../../js/components/searchform/utils/common";
import ModalityRadioSelector from "./filter/ModalityRadioSelector";

let initialState = {
	dateMethod: {
		label: "Personalizado",
		value: 2
	},
	periodType: 0,
	status: 0,
	modality: 0,
	idsFidelity: [],
	sendToEmail: "",
	checkboxStatus: {
		canceled: false,
		toReceive: true,
		received: false,
		resale: false,
		others: false
	},
	start: formatDateToComputerDate(decDaysToDate(new Date(), 365)),
	end: formatDateToComputerDate(new Date())
};

class FilterAndExportBaseModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filteredStatements: props.filteredStatements,
			errors: {},
			sendOptions: "email"
		};

		this.formHandleSubmit = this.formHandleSubmit.bind(props);
	}

	close = () => {
		if (this.props.isExport) {
			this.props.openOrCloseExportModal(false);
		} else {
			this.props.openOrCloseFilterModal(false);
		}
	};

	componentDidMount() {
		this.setState({
			filteredStatements: this.props.filteredStatements,
			errors: this.props.errors
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			filteredStatements: nextProps.filteredStatements,
			errors: nextProps.errors
		});
	}

	handleChangeFilterStatements = (newStatement = {}) => {
		const { filteredStatements, sendOptions } = this.state;
		this.mergedStatements = Object.assign({}, filteredStatements, newStatement, {
			fileType: sendOptions
		});
		this.setState({ filteredStatements: this.mergedStatements, errors: {} });
	};

	formHandleSubmit = dataToSubmitFromForm => {
		if (!dataToSubmitFromForm.isValid) {
			this.setState({ errors: dataToSubmitFromForm.errors });
			return false;
		}

		this.props.handleChangeFilterStatements(this.props.filteredStatements, this.mergedStatements);
		this.props.handleErrors({});

		// Download XLSX AND CSV
		if (this.props.isExport && this.state.sendOptions !== "email") {
			// Send props to Modal
			this.handleChangeFilterStatements();

			this.props.isDownload(true);
			this.props.exportToDownloadSales(this.mergedStatements);
			return false;
		}

		// Send props to Modal
		this.props.isDownload(false);

		// Send Email
		if (this.props.isExport) {
			this.props.exportSales(this.mergedStatements);
		} else {
			this.props.getAllSales(this.mergedStatements, true); // Filter
		}
	};

	handleReset = () => {
		this.handleChangeFilterStatements(initialState);
		this.setState({ filteredStatements: initialState, errors: {} });
		return false;
	};

	handleSendToEmail = e => {
		this.setState({
			sendOptions: e.value
		});
	};

	componentWillReceiveProps() {
		if (this.props.isFetching) {
			return false;
		}
	}

	componentWillMount() {
		if (window.innerWidth <= 576) {
			document.getElementById("body").style.overflow = "hidden";
		}

		this.props.getFidelityPlansFromUserSales();
	}

	componentWillUnmount() {
		if (window.innerWidth <= 576) {
			document.getElementById("body").style.overflow = "auto";
		}
	}

	render() {
		const { filteredStatements, errors, sendOptions } = this.state;

		return (
			<ModalTooLongContent>
				<div>
					<ModalTooLongContentTitle
						close={this.close}
						title={this.props.isExport ? `Exportar minhas vendas` : `Filtro de vendas`}
					/>
					<div className="my-sales-export">
						<Form noValidate id="form-sales-export" submit={this.formHandleSubmit}>
							<div className="type-period-filters">
								<PeriodTypeRadioSelector
									type={filteredStatements.periodType}
									onChange={this.handleChangeFilterStatements}
								/>
								<Select
									id="period-select"
									selected={filteredStatements.dateMethod}
									onChange={event => this.handleChangeFilterStatements({ dateMethod: event })}
									options={[
										{
											label: "Mês atual",
											value: 1
										},
										{
											label: "Personalizado",
											value: 2
										}
									]}
									data-action="filter-and-export-base-modal-period-select"
								/>
							</div>

							<DatePeriodFilter
								onChange={this.handleChangeFilterStatements}
								maxIntervalBetweenDates={365}
								dateFilterPeriodMethod={filteredStatements.dateMethod.value}
								isFilter={this.props.isFilter}
								startDate={filteredStatements.start}
								endDate={filteredStatements.end}
								errors={{
									start:
										errors.startDateFilter === "valueMissing" ? "Campo obrigatório!" : undefined,
									end: errors.endDateFilter === "valueMissing" ? "Campo obrigatório!" : undefined
								}}
							/>

							{this.props.isExport && (
								<div className="row">
									<div className="col-xs-16">
										<div className="pt-16 input-component no-padding">
											<label className="input-component__label">
												<h5>Exportar arquivo de vendas:</h5>
											</label>
											<Radio
												onChange={this.handleSendToEmail}
												horizontally={!isMobile()}
												options={[
													{
														label: "Receber por email",
														value: "email",
														checked: sendOptions === "email"
													},
													// {
													// 	label: "Download em Excel",
													// 	value: "xlsx",
													// 	checked: sendOptions === "xlsx"
													// },
													{
														label: "Download em CSV",
														value: "csv",
														checked: sendOptions === "csv"
													}
												]}
												data-action="filter-and-export-base-modal-type-export-radio"
											/>
										</div>
									</div>
									{sendOptions === "email" && (
										<div className="col-xs-16">
											<Input
												value={filteredStatements.sendToEmail}
												name="sendToEmail"
												onChange={event =>
													this.handleChangeFilterStatements({ sendToEmail: event })
												}
												placeholder="Insira seu e-mail"
												errorMessage={
													errors.sendToEmail === "valueMissing"
														? "Campo obrigatório!"
														: undefined || errors.sendToEmail === "typeMismatch"
														? "Isso não parece ser um e-mail válido :("
														: undefined
												}
												id="sendToEmail"
												type="email"
												required
												label={<h5>*Enviar para:</h5>}
												title="E-mail para exportação"
												data-action="filter-and-export-base-modal-email-to"
											/>
										</div>
									)}
								</div>
							)}

							<div className="check-filters">
								<FidelityPlansCheckboxSelector
									fidelityPlans={this.props.fidelityPlansFromUserSales}
									isFetching={this.props.fidelityPlansIsFetching}
									selecteds={filteredStatements.idsFidelity}
									onChange={event => this.handleChangeFilterStatements(event)}
								/>
								{this.props.isExport && (
									<StatusCheckboxSelector
										isRequired={true}
										onChange={this.handleChangeFilterStatements}
										selecteds={filteredStatements.checkboxStatus}
										status={filteredStatements.status}
									/>
								)}

								{this.props.isFilter && (
									<StatusRadioSelector
										onChange={this.handleChangeFilterStatements}
										status={filteredStatements.status}
									/>
								)}
								{this.props.isFilter && (
									<ModalityRadioSelector
										onChange={this.handleChangeFilterStatements}
										modality={filteredStatements.modality}
									/>
								)}
							</div>

							<div className="filter-button">
								<Button
									type="button"
									className="btn-gray-lg-o"
									onClick={() => this.handleReset()}
									data-action="filter-and-export-base-modal-clean-filters"
								>
									Limpar filtros
								</Button>
								<Button
									type="submit"
									className={`btn-primary-lg ${this.props.isExportFetching ? "is-loading" : ""}`}
									disabled={this.props.isExportFetching}
									data-action="filter-and-export-base-modal-export-or-filter"
								>
									{!this.props.isExportFetching && this.props.isExport && "Exportar"}
									{this.props.isFilter && "Filtrar"}
									{this.props.isExportFetching && <Loading />}
								</Button>
							</div>
						</Form>
					</div>
				</div>
			</ModalTooLongContent>
		);
	}
}

const mapStateToProps = state => ({
	filteredStatements: state.mySales.filteredStatements,
	fidelityPlansFromUserSales: state.util.fidelityPlansFromUserSales,
	fidelityPlansIsFetching: state.util.isFetching,
	isExportFetching: state.mySales.isExportFetching,
	errors: state.mySales.errors
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleChangeFilterStatements,
			getFidelityPlansFromUserSales,
			exportSales,
			exportToDownloadSales,
			handleErrors,
			handleResetFilterAndExport,
			openOrCloseExportModal,
			openOrCloseFilterModal,
			getAllSales
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(FilterAndExportBaseModal);
